//
// Create an image load promise that will either resolve or reject based
// on a default timout period or http error.
//
export default function loadImage(url: string, timeout = 5000, image = Image) {
    return new Promise((resolve, reject) => {
        const img = new image();

        img.addEventListener('load', () => {
            resolve(img);
        });

        img.addEventListener('error', () => {
            const error = new Error('Invalid image');
            error.name = 'ImageError';
            reject(error);
        });

        // Load the image.
        img.src = url;

        // Fail the image load if it's taken too long.
        setTimeout(() => {
            const error = new Error(`Timeout after ${timeout} ms`);
            error.name = 'TimeoutError';
            reject(error);
        }, timeout);
    });
}
